import { Icon } from "@hoylu/client-common";
import React from "react";
import { useDispatch } from "react-redux";
import { DashboardOption } from "@/enums/DashboardOption.enum";
import {
  activateDashboardOption,
  setSearchTerm,
} from "../state/workspaces/workspaces.actions";
import Styles from "./FilterByWorkspaceName.module.css";
import { SearchInput } from "./inputs/SearchInput";

const searchIconStyle: React.CSSProperties = { color: "var(--theme-text)" };

export const FilterByWorkspaceName: React.FC<{ searchTerm: string }> = ({
  searchTerm,
}) => {
  const dispatch = useDispatch();

  const openSearchWorkspaceDialog = () =>
    dispatch(
      activateDashboardOption({
        optionType: DashboardOption.SEARCH_WORKSPACE,
      }),
    );

  const handleChange = (value: string) => dispatch(setSearchTerm(value));

  return (
    <>
      <SearchInput
        handleChange={handleChange}
        responsive
        searchTerm={searchTerm}
      />
      <div className={Styles.searchIcon}>
        <Icon
          hoverStyle={searchIconStyle}
          icon="hoylu-ui-icons-search"
          onClick={openSearchWorkspaceDialog}
          style={searchIconStyle}
          testId="search-workspace"
        />
      </div>
    </>
  );
};
